<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header pb-0">
            <h4>Banco de Imágenes</h4>
            <span class="text-muted small ms-2">
              Mostrando {{ items.length }} de {{ pagination.total }} registros.
            </span>
          </div>
          <div class="card-body">
            <!-- Tabs de búsqueda -->
            <ul class="nav nav-tabs search-tabs mb-3" role="tablist">
              <li class="nav-item">
                <a class="nav-link" :class="{ active: searchTab === 'filtros' }" href="javascript:void(0)"
                  @click="searchTab = 'filtros'">BÚSQUEDA POR FILTROS</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" :class="{ active: searchTab === 'excel' }" href="javascript:void(0)"
                  @click="searchTab = 'excel'">BÚSQUEDA POR EXCEL</a>
              </li>
            </ul>

            <!-- Panel BÚSQUEDA POR FILTROS -->
            <div v-show="searchTab === 'filtros'" class="search-filters mb-4">
              <!-- Fila 1: Producto, Fecha, Consultar -->
              <div class="row g-3 align-items-end mb-3">
                <div class="col-md-6 col-lg-4">
                  <label class="form-label small fw-semibold">Filtrado Por Producto:</label>
                  <input v-model.trim="filters.producto" type="text" class="form-control" placeholder="Producto" />
                </div>
                <div class="col-md-6 col-lg-4">
                  <label class="form-label small fw-semibold">Filtrado Por Fecha:</label>
                  <Datepicker class="datepicker-here digits" :model-value="dateRange" range :enable-time-picker="false"
                    placeholder="Selecciona rango" :format="formatDateRange" :locale="es" auto-apply
                    @update:model-value="onDateRangeChange" />
                </div>
                <div class="col-md-12 col-lg-4">
                  <button type="button"
                    class="btn btn-primary w-100 d-flex align-items-center justify-content-center gap-2"
                    @click="consultar">
                    <vue-feather type="search" size="16" />
                    Consultar
                  </button>
                </div>
              </div>
              <!-- Fila 2: Resolución, Redimensionada, Descargar Informe -->
              <div class="row g-3 align-items-end">
                <div class="col-md-6 col-lg-4">
                  <label class="form-label small fw-semibold">Filtrado Por Resolución:</label>
                  <select v-model="filters.resolucion" class="form-select">
                    <option value="">Todas</option>
                    <option value="128">128X128</option>
                    <option value="256">256X256</option>
                    <option value="512">512X512</option>
                    <option value="1024">1024X1024</option>
                  </select>
                </div>
                <div class="col-md-6 col-lg-4">
                  <label class="form-label small fw-semibold">Redimensionada:</label>
                  <select v-model="filters.redimensionada" class="form-select">
                    <option value="">Ambas</option>
                    <option value="1">Sí</option>
                    <option value="0">No</option>
                  </select>
                </div>
                <div class="col-md-12 col-lg-4">
                  <button type="button"
                    class="btn btn-primary w-100 d-flex align-items-center justify-content-center gap-2"
                    @click="descargarInforme" :disabled="loadingInforme">
                    <vue-feather type="download" size="16" />
                    {{ loadingInforme ? "..." : "Exportar resultados" }}
                  </button>
                </div>
              </div>
            </div>

            <!-- Panel BÚSQUEDA POR EXCEL -->
            <div v-show="searchTab === 'excel'" class="search-excel mb-4">
              <div class="row g-3 align-items-stretch">
                <!-- Columna 1: Subir Excel y buscar -->
                <div class="col-md-6">
                  <div class="card h-100 border">
                    <div class="card-body">
                      <h6 class="card-title fw-semibold mb-3">
                        <vue-feather type="upload-cloud" size="20" class="me-2" />
                        Buscar por Excel
                      </h6>
                      <p class="text-muted small mb-3">
                        Sube un archivo Excel con la columna <strong>Cb</strong>. Se buscarán todos los códigos en la
                        base y se generará un reporte. Máximo <strong>{{ maxFilasExcel }} filas</strong> (sin contar el
                        encabezado).
                      </p>
                      <input type="file" accept=".xlsx,.xls" class="form-control mb-2" @change="onExcelFileChange"
                        ref="excelFileInput" />
                      <p v-if="excelFileError" class="text-danger small mb-2">{{ excelFileError }}</p>
                      <button type="button" class="btn btn-primary w-100" :disabled="!excelFile || loadingExcelSearch"
                        @click="buscarPorExcel">
                        <vue-feather v-if="loadingExcelSearch" type="loader" size="18" class="me-2 spin" />
                        {{ loadingExcelSearch ? "Buscando..." : "Buscar y generar reporte" }}
                      </button>
                    </div>
                  </div>
                </div>
                <!-- Columna 2: Descargar plantilla -->
                <div class="col-md-6">
                  <div class="card h-100 border">
                    <div class="card-body">
                      <h6 class="card-title fw-semibold mb-3">
                        <vue-feather type="file-text" size="20" class="me-2" />
                        Plantilla de búsqueda
                      </h6>
                      <p class="text-muted small mb-3">
                        Descarga la plantilla con el formato correcto. Completa la columna <strong>Cb</strong> con los
                        códigos de producto y súbela para buscar.
                      </p>
                      <button type="button" class="btn btn-outline-primary w-100" @click="descargarPlantilla">
                        <vue-feather type="download" size="18" class="me-2" />
                        Descargar plantilla
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div v-if="!items.length && !loading" class="col-12 text-center py-5 text-muted">
                No hay registros para mostrar.
              </div>
              <div v-else class="order-history table-responsive theme-scrollbar wishlist col-12">
                <table class="table display dataTable table-bordered mb-0">
                  <thead>
                    <tr>
                      <th>Imagen</th>
                      <th>Producto</th>
                      <th>Fecha Alta</th>
                      <th>Fecha Actualización</th>
                      <th>RED128</th>
                      <th>RED256</th>
                      <th>RED512</th>
                      <th>RED1024</th>
                      <th>Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="loading">
                      <td colspan="12" class="text-center py-4">
                        Cargando imágenes...
                      </td>
                    </tr>
                    <tr v-for="row in items" :key="row.id" class="odd">
                      <td class="sorting_1">
                        <img v-if="row.url" :src="row.url" :alt="row.producto" class="img-fluid img-80" />
                        <span v-else class="text-muted">—</span>
                      </td>
                      <td class="sorting_1">
                        <div class="product-name">
                          <h6 class="mb-0">{{ row.producto }}</h6>
                        </div>
                      </td>
                      <td class="sorting_1">{{ formatDate(row.fecha) }}</td>
                      <td class="sorting_1">
                        <span v-if="row.fecha_Update">{{ formatDate(row.fecha_Update) }}</span>
                        <span v-else class="text-muted">—</span>
                      </td>
                      <td class="sorting_1">
                        <span :class="statusBadge(row.url128)">{{ statusText(row.url128) }}</span>
                      </td>
                      <td class="sorting_1">
                        <span :class="statusBadge(row.url256)">{{ statusText(row.url256) }}</span>
                      </td>
                      <td class="sorting_1">
                        <span :class="statusBadge(row.url512)">{{ statusText(row.url512) }}</span>
                      </td>
                      <td class="sorting_1">
                        <span :class="statusBadge(row.url1024)">{{ statusText(row.url1024) }}</span>
                      </td>
                      <td class="sorting_1">
                        <div class="action-buttons">
                          <button type="button" class="btn btn-success btn-action text-white" title="Actualizar"
                            @click.stop="openUpdateModal(row)">
                            <vue-feather type="edit" size="20" />
                            <span class="btn-action-label">Actualizar</span>
                          </button>
                          <button type="button" class="btn btn-primary btn-action text-white" title="Descargar"
                            @click.stop="openDownloadModal(row)">
                            <vue-feather type="download" size="20" />
                            <span class="btn-action-label">Descargar</span>
                          </button>
                          <button type="button" class="btn btn-danger btn-action text-white" title="Remover"
                            @click.stop="openDeleteModal(row)">
                            <vue-feather type="trash-2" size="20" />
                            <span class="btn-action-label">Remover</span>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="mt-2" v-if="selectedProductCode">
              <small class="text-muted">Producto seleccionado: {{ selectedProductCode }}</small>
            </div>

            <PaginacionTabla :pagina="pagination.page" :total-paginas="pagination.totalPages"
              :deshabilitado="loading" @cambiar="goToPage" />
          </div>
        </div>
      </div>
    </div>

    <Teleport to="body">
      <ImageUpdateModal :key="selectedProductCode || 'modal'" :visible="showModal" :product-code="selectedProductCode"
        @close="showModal = false; selectedProductCode = null" @updated="handleUpdated" />
    </Teleport>

    <!-- Modal de confirmación de eliminación -->
    <Teleport to="body">
      <div v-if="showDeleteModal" class="delete-modal-overlay">
        <div class="delete-modal-backdrop" @click="closeDeleteModal"></div>
        <div class="delete-modal">
          <button type="button" class="btn-close delete-modal-close" @click="closeDeleteModal"
            aria-label="Cerrar"></button>
          <div v-if="productToDelete" class="delete-modal-content">
            <div class="delete-modal-image">
              <img v-if="deleteModalImageUrl" :src="deleteModalImageUrl" :alt="productToDelete.producto"
                class="img-fluid" />
              <div v-else class="delete-modal-no-image text-muted py-4">Sin imagen</div>
            </div>
            <h5 class="delete-modal-title">¿Estás seguro de ELIMINAR este producto?</h5>
            <p class="delete-modal-product text-muted small mb-3">{{ productToDelete.producto }}</p>
            <div class="delete-modal-buttons">
              <button type="button" class="btn btn-cancel-delete" @click="closeDeleteModal">
                <vue-feather type="x" size="18" stroke-width="2.5" />
                Cancelar
              </button>
              <button type="button" class="btn btn-confirm-delete" :disabled="deletingProduct" @click="confirmDelete">
                <vue-feather type="trash-2" size="18" stroke-width="2.5" />
                {{ deletingProduct ? 'Eliminando...' : 'Sí, remover' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Teleport>

    <!-- Modal de opciones de descarga -->
    <Teleport to="body">
      <div v-if="showDownloadModal" class="download-modal-overlay">
        <div class="download-modal-backdrop" @click="closeDownloadModal"></div>
        <div class="download-modal">
          <div class="download-modal-icon">
            <vue-feather type="download-cloud" size="40" stroke-width="1.5" />
          </div>
          <h5 class="download-modal-title">Selecciona una opción de descarga</h5>
          <div class="download-modal-buttons">
            <button type="button" class="btn btn-download-option" @click="downloadOriginal">
              <vue-feather type="download" size="18" stroke-width="2" />
              Descargar Original
            </button>
            <button type="button" class="btn btn-download-option" @click="downloadZip" :disabled="downloadingZip">
              <vue-feather type="archive" size="18" stroke-width="2" />
              {{ downloadingZip ? "Preparando ZIP..." : "Descargar Original y Redimensiones" }}
            </button>
          </div>
          <button type="button" class="btn-close download-modal-close" @click="closeDownloadModal"
            aria-label="Cerrar"></button>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script>
import ImageUpdateModal from "@/components/ImageUpdateModal.vue";
import PaginacionTabla from "@/components/PaginacionTabla.vue";
import JSZip from "jszip";
import { apiFetch } from "@/services/api";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import * as XLSX from "xlsx";
import { es } from "date-fns/locale";

export default {
  name: "ImageBank",
  components: {
    ImageUpdateModal,
    PaginacionTabla,
  },
  data() {
    const now = new Date();
    const startDate = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0);
    const endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
    return {
      items: [],
      loading: false,
      loadingInforme: false,
      searchTab: "filtros",
      dateRange: [startDate, endDate],
      filters: {
        producto: "",
        resolucion: "",
        redimensionada: "",
      },
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 1,
      },
      showModal: false,
      selectedProductCode: null,
      showDownloadModal: false,
      selectedDownloadRow: null,
      downloadingZip: false,
      showDeleteModal: false,
      productToDelete: null,
      deletingProduct: false,
      excelFile: null,
      excelFileError: null,
      loadingExcelSearch: false,
    };
  },
  computed: {
    maxFilasExcel() {
      return this.$store.state.configuracion.busquedaExcel.banco.maxFilas;
    },
    dateRangeFromModel() {
      const range = this.dateRange;
      if (!range) return ["", ""];
      const start = Array.isArray(range) ? range[0] : range;
      const end = Array.isArray(range) && range[1] ? range[1] : start;
      // Fecha local (no toISOString, que pasa a UTC y puede correr el día).
      const toYyyyMmDd = (d) =>
        d && d instanceof Date && !Number.isNaN(d.getTime())
          ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`
          : "";
      return [toYyyyMmDd(start), toYyyyMmDd(end)];
    },
    deleteModalImageUrl() {
      const p = this.productToDelete;
      if (!p) return null;
      return p.url || p.url1024 || p.url512 || p.url256 || p.url128 || null;
    },
  },
  created() {
    this.consultar();
    this.cargarMaxFilasExcel();
  },
  methods: {
    /** Límite de filas de "Buscar por Excel" configurado en Configuración > Búsqueda Excel. */
    async cargarMaxFilasExcel() {
      try {
        await this.$store.dispatch("configuracion/consultarBusquedaExcel");
      } catch (e) {
        console.error("No se pudo consultar el límite de filas de la búsqueda por Excel:", e);
      }
    },
    /** El rango abarca días completos: inicio a las 00:00:00 y fin a las 23:59:59. */
    onDateRangeChange(range) {
      if (!Array.isArray(range) || !range[0]) {
        this.dateRange = range;
        return;
      }
      const inicio = new Date(range[0]);
      inicio.setHours(0, 0, 0, 0);
      const fin = new Date(range[1] || range[0]);
      fin.setHours(23, 59, 59, 999);
      this.dateRange = [inicio, fin];
    },
    formatDateRange(dates) {
      const fmt = (d) => {
        if (!d || !(d instanceof Date) || Number.isNaN(d.getTime())) return '';
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        const hora = `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
        return `${day}/${month}/${year}, ${hora}`;
      };
      if (Array.isArray(dates)) {
        const parts = dates.map(fmt).filter(Boolean);
        return parts.length ? parts.join(' - ') : '';
      }
      return fmt(dates);
    },
    consultar() {
      this.fetchPage(1, true);
    },
    async fetchPage(page, showSuccessModal = false) {
      this.loading = true;
      const baseUrl =
        process.env.VUE_APP_API_BASE_URL || "http://localhost:3000";

      try {
        const params = new URLSearchParams({
          page: String(page),
          pageSize: String(this.pagination.pageSize),
        });
        if (this.filters.producto) params.set("producto", this.filters.producto);
        const [fechaDesde, fechaHasta] = this.dateRangeFromModel;
        if (fechaDesde) params.set("fechaDesde", fechaDesde);
        if (fechaHasta) params.set("fechaHasta", fechaHasta);
        if (this.filters.resolucion) params.set("resolucion", this.filters.resolucion);
        if (this.filters.redimensionada !== "") params.set("redimensionada", this.filters.redimensionada);

        const response = await apiFetch(`${baseUrl}/api/imagenes?${params.toString()}`);
        if (!response.ok) {
          const data = await response.json().catch(() => ({}));
          throw new Error(data.message || `Error HTTP ${response.status}`);
        }

        const data = await response.json();
        this.items = data.data || [];
        this.pagination = data.pagination || this.pagination;
        if (showSuccessModal) {
          const total = this.pagination.total ?? 0;
          Swal.fire({
            title: "Consulta Exitosa",
            html: `<div class="mb-3"><p>Se han encontrado ${total} producto${total !== 1 ? "s" : ""}.</p></div>`,
            icon: "success",
            confirmButtonText: "Aceptar",
          });
        }
      } catch (error) {
        console.error("Error al obtener imágenes:", error);
        Swal.fire({
          title: "Error en la Consulta",
          text: "No se pudieron cargar las imágenes. Por favor, intenta nuevamente.",
          icon: "error",
          confirmButtonText: "Aceptar",
        });
      } finally {
        this.loading = false;
      }
    },
    goToPage(page) {
      if (
        page < 1 ||
        page > this.pagination.totalPages ||
        page === this.pagination.page ||
        this.loading
      ) {
        return;
      }
      this.fetchPage(page);
    },
    statusText(url) {
      return url ? "Disponible" : "No disponible";
    },
    statusBadge(url) {
      return url
        ? "badge bg-success-subtle text-success"
        : "badge bg-light text-muted";
    },
    openUpdateModal(row) {
      if (!row || !row.producto) return;
      this.selectedProductCode = row.producto;
      this.showModal = true;
    },
    openDeleteModal(row) {
      if (!row || !row.producto) return;
      this.productToDelete = row;
      this.showDeleteModal = true;
    },
    closeDeleteModal() {
      this.showDeleteModal = false;
      this.productToDelete = null;
      this.deletingProduct = false;
    },
    async confirmDelete() {
      const row = this.productToDelete;
      if (!row || !row.producto) return;

      const baseUrl =
        process.env.VUE_APP_API_BASE_URL || "http://localhost:3000";

      try {
        this.deletingProduct = true;
        const response = await apiFetch(
          `${baseUrl}/api/imagenes/${encodeURIComponent(row.producto)}`,
          { method: "DELETE" }
        );
        if (!response.ok) {
          const data = await response.json().catch(() => ({}));
          throw new Error(data.message || `Error HTTP ${response.status}`);
        }
        this.closeDeleteModal();
        await this.fetchPage(this.pagination.page);
      } catch (error) {
        console.error("Error al eliminar producto:", error);
        alert("No se pudo eliminar el producto.");
      } finally {
        this.deletingProduct = false;
      }
    },
    onExcelFileChange(event) {
      const [file] = event.target.files || [];
      this.excelFileError = null;
      this.excelFile = null;
      if (!file) return;
      const ext = (file.name || "").toLowerCase();
      if (!ext.endsWith(".xlsx") && !ext.endsWith(".xls")) {
        this.excelFileError = "Solo se permiten archivos .xlsx o .xls";
        event.target.value = "";
        return;
      }
      this.excelFile = file;
    },
    extraerColumnaCb(workbook) {
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const data = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: "" });
      if (!data.length) return [];
      const header = data[0].map((h) => String(h || "").trim().toLowerCase());
      const cbIdx = header.findIndex((h) => h === "cb");
      if (cbIdx === -1) return null;
      const codigos = [];
      for (let i = 1; i < data.length; i++) {
        const val = data[i][cbIdx];
        const str = String(val ?? "").trim().replace(/\s/g, "");
        if (str && /^\d{5,14}$/.test(str)) codigos.push(str);
      }
      return codigos;
    },
    async buscarPorExcel() {
      if (!this.excelFile) return;
      this.loadingExcelSearch = true;
      this.excelFileError = null;
      const baseUrl = process.env.VUE_APP_API_BASE_URL || "http://localhost:3000";

      try {
        const arrayBuffer = await this.excelFile.arrayBuffer();
        const workbook = XLSX.read(arrayBuffer, { type: "array" });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const allRows = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: "" });
        await this.cargarMaxFilasExcel();
        const filasDatos = Math.max(allRows.length - 1, 0);
        if (filasDatos > this.maxFilasExcel) {
          this.excelFileError =
            `El archivo excede el límite de ${this.maxFilasExcel} filas.` +
            `Filas detectadas: ${filasDatos}`;
          return;
        }
        const codigos = this.extraerColumnaCb(workbook);

        if (codigos === null) {
          this.excelFileError = "No se encontró la columna 'Cb' en el archivo.";
          return;
        }
        if (codigos.length === 0) {
          this.excelFileError = "No hay códigos válidos (5-14 dígitos) en la columna Cb.";
          return;
        }

        const response = await apiFetch(`${baseUrl}/api/imagenes/buscar`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ productos: codigos }),
        });

        if (!response.ok) {
          const data = await response.json().catch(() => ({}));
          throw new Error(data.message || `Error HTTP ${response.status}`);
        }

        const { data: rows } = await response.json();
        const mapByProducto = {};
        (rows || []).forEach((r) => {
          mapByProducto[r.producto] = r;
        });
        const reporteRows = codigos.map((cb) => {
          const r = mapByProducto[cb];
          if (r) return r;
          return {
            producto: cb,
            _sinRegistro: true,
            UserId: "sin registro",
            fecha: "sin registro",
            UserId_Update: "sin registro",
            fecha_Update: "sin registro",
            url: "sin registro",
            red128: false,
            red256: false,
            red512: false,
            red1024: false,
            url128: "sin registro",
            url256: "sin registro",
            url512: "sin registro",
            url1024: "sin registro",
          };
        });
        this.generarReporteExcel(reporteRows);
      } catch (error) {
        console.error("Error en búsqueda por Excel:", error);
        this.excelFileError = error.message || "No se pudo completar la búsqueda.";
      } finally {
        this.loadingExcelSearch = false;
      }
    },
    generarReporteExcel(rows) {
      const headers = [
        "Cb",
        "UserId_Alta",
        "Fecha_Alta",
        "UserId_Actualizacion",
        "Fecha_Actualizacion",
        "URL Original",
        "RED128",
        "RED256",
        "RED512",
        "RED1024",
        "URL128",
        "URL256",
        "URL512",
        "URL1024",
      ];
      const sinRegistro = (r) => r._sinRegistro === true;
      const data = [
        headers,
        ...rows.map((r) => {
          const esSinRegistro = sinRegistro(r);
          const disp = (v) =>
            esSinRegistro ? "Sin registro" : v ? "Disponible" : "No Disponible";
          const val = (v) => (esSinRegistro ? "Sin registro" : v || "");
          return [
            r.producto,
            val(r.UserId),
            val(this.formatDate(r.fecha)),
            val(r.UserId_Update),
            val(this.formatDate(r.fecha_Update)),
            val(r.url),
            disp(r.red128),
            disp(r.red256),
            disp(r.red512),
            disp(r.red1024),
            val(r.url128),
            val(r.url256),
            val(r.url512),
            val(r.url1024),
          ];
        }),
      ];
      const ws = XLSX.utils.aoa_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Reporte");
      const d = new Date();
      const fecha = `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
      XLSX.writeFile(wb, `Reporte banco de imágenes ${fecha}.xlsx`);
    },
    descargarPlantilla() {
      const headers = ["cb"];
      const ws = XLSX.utils.aoa_to_sheet([headers]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Plantilla");
      XLSX.writeFile(wb, "plantilla-busqueda-Banco-Imagenes.xlsx");
    },
    openDownloadModal(row) {
      if (!row || !row.producto) return;
      if (!row.url) {
        alert("No hay imagen original para descargar.");
        return;
      }
      this.selectedDownloadRow = row;
      this.showDownloadModal = true;
    },
    closeDownloadModal() {
      this.showDownloadModal = false;
      this.selectedDownloadRow = null;
      this.downloadingZip = false;
    },
    async downloadOriginal() {
      const row = this.selectedDownloadRow;
      if (!row?.url) return;
      try {
        const response = await fetch(row.url, { mode: "cors" });
        if (!response.ok) throw new Error("Error al obtener la imagen");
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${row.producto}.jpg`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        this.closeDownloadModal();
      } catch (error) {
        console.error("Error al descargar imagen:", error);
        alert("No se pudo descargar la imagen. Puede haber restricciones de CORS.");
      }
    },
    async downloadZip() {
      const row = this.selectedDownloadRow;
      if (!row) return;

      const files = [
        { url: row.url, name: `${row.producto}.jpg` },
        { url: row.url128, name: `${row.producto}-128x128.jpg` },
        { url: row.url256, name: `${row.producto}-256x256.jpg` },
        { url: row.url512, name: `${row.producto}-512x512.jpg` },
        { url: row.url1024, name: `${row.producto}-1024x1024.jpg` },
      ].filter((f) => f.url);

      if (!files.length) {
        alert("No hay imágenes para descargar.");
        return;
      }

      this.downloadingZip = true;
      try {
        const zip = new JSZip();
        for (const file of files) {
          const response = await fetch(file.url, { mode: "cors" });
          if (!response.ok) throw new Error(`Error al obtener ${file.name}`);
          const blob = await response.blob();
          zip.file(file.name, blob);
        }
        const content = await zip.generateAsync({ type: "blob" });
        const url = URL.createObjectURL(content);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${row.producto}.zip`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        this.closeDownloadModal();
      } catch (error) {
        console.error("Error al crear ZIP:", error);
        alert("No se pudo descargar el archivo ZIP. Las imágenes pueden estar en otro dominio (CORS).");
      } finally {
        this.downloadingZip = false;
      }
    },
    formatDate(value) {
      if (!value) return "";
      const d = new Date(value);
      if (Number.isNaN(d.getTime())) return value;
      return d.toLocaleString();
    },
    handleUpdated() {
      this.fetchPage(this.pagination.page);
    },
    async descargarInforme() {
      this.loadingInforme = true;
      const baseUrl =
        process.env.VUE_APP_API_BASE_URL || "http://localhost:3000";

      try {
        const params = new URLSearchParams({
          page: "1",
          pageSize: "10000",
          informe: "1",
        });
        if (this.filters.producto) params.set("producto", this.filters.producto);
        const [fechaDesdeInf, fechaHastaInf] = this.dateRangeFromModel;
        if (fechaDesdeInf) params.set("fechaDesde", fechaDesdeInf);
        if (fechaHastaInf) params.set("fechaHasta", fechaHastaInf);
        if (this.filters.resolucion) params.set("resolucion", this.filters.resolucion);
        if (this.filters.redimensionada !== "") params.set("redimensionada", this.filters.redimensionada);

        const response = await apiFetch(`${baseUrl}/api/imagenes?${params.toString()}`);
        if (!response.ok) throw new Error("Error al obtener el informe");

        const data = await response.json();
        const rows = data.data || [];

        const headers = [
          "Cb",
          "UserId_Alta",
          "Fecha_Alta",
          "UserId_Actualización",
          "Fecha_Actualización",
          "URL Original",
          "RED128",
          "RED256",
          "RED512",
          "RED1024",
          "URL128",
          "URL256",
          "URL512",
          "URL1024",
        ];
        const csvRows = [
          headers.join(","),
          ...rows.map((r) =>
            [
              r.producto,
              r.UserId,
              `"${this.formatDate(r.fecha)}"`,
              r.UserId_Update || "",
              `"${this.formatDate(r.fecha_Update)}"`,
              `"${(r.url || "").replace(/"/g, '""')}"`,
              r.red128 ? "Disponible" : "No Disponible",
              r.red256 ? "Disponible" : "No Disponible",
              r.red512 ? "Disponible" : "No Disponible",
              r.red1024 ? "Disponible" : "No Disponible",
              `"${(r.url128 || "").replace(/"/g, '""')}"`,
              `"${(r.url256 || "").replace(/"/g, '""')}"`,
              `"${(r.url512 || "").replace(/"/g, '""')}"`,
              `"${(r.url1024 || "").replace(/"/g, '""')}"`,
            ].join(",")
          ),
        ];
        const csv = "\uFEFF" + csvRows.join("\n");
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `informe_imagenes_${new Date().toISOString().slice(0, 10)}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error al descargar informe:", error);
        alert("No se pudo descargar el informe.");
      } finally {
        this.loadingInforme = false;
      }
    },
  },
};
</script>

<style scoped>
.search-tabs .nav-link {
  font-weight: 600;
  color: #6c757d;
  border: none;
  border-bottom: 2px solid transparent;
}

.search-tabs .nav-link:hover {
  color: #6f42c1;
}

.search-tabs .nav-link.active {
  color: #6f42c1;
  border-bottom-color: #6f42c1;
  background: transparent;
}

.action-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}

.btn-action {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  min-width: 92px;
  padding: 0.45rem 0.9rem;
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1.1;
  border: none;
  border-radius: 30px;
  transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
}

.btn-action:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.15);
  opacity: 0.95;
}

.btn-action:active {
  transform: translateY(0);
}

.btn-action-label {
  white-space: nowrap;
  font-size: 10px;
}

@media (max-width: 1200px) {
  .btn-action-label {
    display: none;
  }

  .btn-action {
    min-width: 0;
    padding: 0.5rem;
  }
}

/* Modal de opciones de descarga */
.download-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999990;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.download-modal-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.download-modal {
  position: relative;
  background: #fff;
  border-radius: 0.5rem;
  padding: 2rem;
  max-width: 420px;
  width: 100%;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  text-align: center;
}

.download-modal-icon {
  width: 72px;
  height: 72px;
  margin: 0 auto 1rem;
  background: rgba(92, 97, 242, 0.12);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--theme-deafult, #5c61f2);
}

.download-modal-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #212529;
  margin-bottom: 1.5rem;
}

.download-modal-buttons {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.btn-download-option {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.65rem 1rem;
  font-weight: 600;
  border-radius: 0.5rem;
  border: none;
  background: linear-gradient(135deg, var(--theme-deafult, #5c61f2) 0%, #4a4fd6 100%);
  color: #fff;
  transition: opacity 0.2s, transform 0.1s, box-shadow 0.2s;
  box-shadow: 0 4px 12px rgba(92, 97, 242, 0.3);
}

.btn-download-option:hover:not(:disabled) {
  opacity: 0.95;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(92, 97, 242, 0.4);
}

.btn-download-option:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.download-modal-close {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
}

/* Modal de confirmación de eliminación */
.delete-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999990;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.delete-modal-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.delete-modal {
  position: relative;
  background: #fff;
  border-radius: 0.5rem;
  padding: 2rem;
  max-width: 420px;
  width: 100%;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  text-align: center;
}

.delete-modal-close {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
}

.delete-modal-image {
  margin-bottom: 1.25rem;
  max-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.delete-modal-image img {
  max-height: 200px;
  width: auto;
  object-fit: contain;
}

.delete-modal-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #212529;
  margin-bottom: 0.25rem;
}

.delete-modal-product {
  font-size: 0.875rem;
}

.delete-modal-buttons {
  display: flex;
  gap: 0.75rem;
  justify-content: center;
  margin-top: 1.5rem;
}

.btn-cancel-delete {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.55rem 1.25rem;
  font-weight: 600;
  border-radius: 0.5rem;
  border: none;
  background: linear-gradient(135deg, var(--theme-deafult, #5c61f2) 0%, #4a4fd6 100%);
  color: #fff;
  transition: opacity 0.2s, transform 0.1s, box-shadow 0.2s;
  box-shadow: 0 4px 12px rgba(92, 97, 242, 0.3);
}

.btn-cancel-delete:hover {
  opacity: 0.95;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(92, 97, 242, 0.4);
}

.btn-confirm-delete {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.55rem 1.25rem;
  font-weight: 600;
  border-radius: 0.5rem;
  border: none;
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: #fff;
  transition: opacity 0.2s, transform 0.1s, box-shadow 0.2s;
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.35);
}

.btn-confirm-delete:hover:not(:disabled) {
  opacity: 0.95;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(220, 53, 69, 0.45);
}

.btn-confirm-delete:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
